import { Command, selectTracesByNodeId, State } from '@store/index';
import { useSelector } from 'react-redux';
import { useTheme } from '../../styles';
import { useNodeError } from './useNodeError';

interface Props {
  command: Command | undefined;
  selected: boolean;
}

export const useNodeOutline = ({ command, selected }: Props) => {
  const { nodeStatus } = useNodeError({ command });

  const theme = useTheme();
  const running = useSelector((state: State) => state.tabs.active.run.running);
  const nodeTrace = useSelector((state: State) => selectTracesByNodeId(state, command?.node?.id));
  const nodeWebhooks = running && nodeTrace?.metadata?.webhooks ? nodeTrace.metadata.webhooks || [] : [];

  if (!command) return { nodeOutline: 'none' };

  const getOutlineStroke = () => {
    if (nodeStatus === 'failed') return `${theme.telnyx.red} solid 2px`;
    if (nodeStatus === 'processing' || nodeWebhooks.length > 0) return `${theme.telnyx.yellow} solid 2px`;
    if (nodeStatus === 'completed') return `${theme.telnyx.green} solid 2px`;

    if (selected) return `${theme.telnyx.blue} solid 2px`;
    return 'none';
  };

  const nodeOutline = getOutlineStroke();
  return { nodeOutline };
};
